<main id="players-maintenance" class="maintenance-form">
    <h2>Edit Player</h2>
    <div>
        Username: <input type="text" class="input"  bind:value={username}>
        First name: <input type="text" class="input"  bind:value={first_name}>
    </div>
    <div class="buttons">
        <button class="select-button" on:click={saveData}>Save</button>
        <button class="select-button" on:click={deletePlayer}>Delete</button>
        <button class="select-button" on:click={close}>Close</button>
    </div>
</main>

<style>
    #players-maintenance {
        display: none;
    }
</style>

<script>
    import { user } from './data-store.js'
    import { writeToUser } from './user.js';
    import { elementDisplay } from './utilities'

    let username = '';
    let first_name = '';
    $: first_name = checkUsername(username);

    function checkUsername(username) {
        // Display pairs that match or the name if a full username
        let first_name = ''
        if ($user.players[username]) {
            first_name = $user.players[username];
        };
        return first_name;
    };

    function validatePlayer(username, first_name) {
        // Validate a player's data
        if (!username) {
            alert('Must provide a username.');
            return false;
        };
        if (!first_name) {
            alert('Must provide a first name.');
            return false;
        };
        return true;
    };

    function deletePlayer() {
        // Delete a player
        if (!username || !(username in $user.players)) {
            alert('Must provide a valid username.');
            return;
        };
        for (let pair of $user.pairs) {
            if (username == pair[0] || username == pair[1]) {
                alert('You must remove all pairs for this player before you can remove the player.');
                return;
            };
        };
        if (confirm('Are you sure you want to delete this player?')) {
            delete $user.players[username];
            username = '';
            first_name = '';
            writeToUser();
        }
    }

    function saveData() {
        if (validatePlayer(username, first_name)) {
            $user.players[username] = first_name;
            writeToUser();
            close();
        };
    };

    function close() {
        elementDisplay('players-maintenance', 'none');
    };
</script>